<div class="money-manager">
  <nav class="rail" aria-label="Money Manager sections">
    <div class="rail-title">💰 Money</div>
    <a *ngFor="let item of items"
       class="rail-item"
       [routerLink]="item.path"
       routerLinkActive="on">
      <span class="glyph">{{ item.glyph }}</span>
      <span class="label">{{ item.label }}</span>
    </a>
  </nav>

  <section class="stage">
    <router-outlet></router-outlet>
  </section>
</div>
